export default {
  white: '#ffffff',
  blue: '#8ddaf2',
  yellow: '#f9d594',
  darkBlue: '#425e6c',
  green: '#16c464',
  greenLight: '#8ae1b1',
  grayLight: '#f0f2f5',
  pink: '#ff7875',
  pinkLight: '#fff1f0',
}



// WEBPACK FOOTER //
// ./src/theme.js